import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

// URL base de la API
const API_URL = getApiBaseUrl();

// Crear una instancia de Axios
const api = axios.create({
  baseURL: API_URL,
});

// Configurar un interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
  (config) => {
    // Obtener el token del localStorage
    const token = secureStorage.getItem('authToken');
    
    if (token) {
      // Agregar el token al encabezado de autorización
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const PostDatosPedidoVentaTejido = async (datos) => {
  try {
    const response = await api.post('pedido_ventatejido', datos);
    return response.data;

  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      // Si el error es una respuesta del servidor con un mensaje de error
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      // Si el error no es una respuesta del servidor con un mensaje de error
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const getCargamento = async () => {
  try {
    const response = await api.get(`${API_URL}pedido_ventatejido`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const PostCargaPedido= async (datos) => {
  try {
    const response = await api.post(`${API_URL}cargaPedidoTejido`, datos);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      // Si el error es una respuesta del servidor con un mensaje de error
      throw new Error(' ' + error.response.data.message);
    } else {
      // Si el error no es una respuesta del servidor con un mensaje de error
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

export const updateVentaStock = async (id, data) => {
  try {
    const response = await api.put(`ventaStockTejido/${id}`, data);

    return response.data;
  } catch (error) {
    throw new Error('Error al Actualizar los Datos: ');
  }
};

export const getLiberarCamionesTejido = async () => {
  try {
    const response = await api.get(`${API_URL}liberarCamionesTejido`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

export const putCamionesPedidosTejido = async (id, data) => {
  try {
    const response = await api.put(`${API_URL}camionesTejido/${id}`, data);

    return response.data;
  } catch (error) {
    throw new Error('Error al Actualizar los Datos: ');
  }
};

const updateSalidaStockTejido = async (id, data) => {
  try {
    const response = await api.put(`${API_URL}salidaStockTejido/${id}`, data);

    return response.data;
  } catch (error) {
    throw new Error('Error al Actualizar los Datos: ');
  }
};

export const getDatosHistorial = async () => {
  try {
    const response = await api.get(`${API_URL}historialVenta`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

export const getOneHistorial = async (id_pedido) => {
  try {
    const response = await api.get(`${API_URL}historialRollos/${id_pedido}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

export const getOneRollos = async (n_pedido) => {
  try {
    const response = await api.get(`${API_URL}historialRolos/${n_pedido}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

export const getOnePedidoVentaTejido = async (n_pedido) => {
  try {
    const response = await api.get(`${API_URL}pedido_ventatejidos/${n_pedido}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};
export { PostDatosPedidoVentaTejido, getCargamento, PostCargaPedido, updateSalidaStockTejido};